import React from 'react';
import './ReferenceLegal.css';

const ReferencesLegales = ({ decisionData }) => {
    if (!decisionData) return null;

    return (
        <div id="references_legales" className="content-section">
            {decisionData?.references_legales && decisionData?.references_legales.length > 0 ? (
                <ul className="references-list">
                    {decisionData?.references_legales.map((reference, index) => (
                        <li key={index} className="reference-item">
                            {reference?.type && <p className="info-text"><strong>Type:</strong> {reference?.type}</p>}
                            {reference?.reference && <p className="info-text"><strong>Référence:</strong> {reference?.reference}</p>}
                            {reference?.article && <p className="info-text"><strong>Article:</strong> {reference?.article}</p>}
                            {reference?.description && <p className="info-text"><strong>Description:</strong> {reference?.description}</p>}
                            {reference?.contexte && <p className="info-text"><strong>Contexte:</strong> {reference?.contexte}</p>}
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="no-content-text">Aucune référence légale disponible.</p>
            )}
        </div>
    );
};

export default ReferencesLegales;